import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { determineDeclension as declension, emptyArr } from '@beef/utils';
import { AccumUnit, UNIT_LOCALE } from "../types/accumulators";
import { MAX_UNITS_LENGTH } from "../constants/accumulators";
export var formatInternetAccumulator = function formatInternetAccumulator(rest, size) {
  var data = {};
  var hasRest = !!rest || rest === 0;
  var hasSize = !!size || size === 0;
  if (size && hasRest && hasSize) {
    if (size > MAX_UNITS_LENGTH.KBYTE && size < MAX_UNITS_LENGTH.MEGABYTE) {
      data.displayUnit = UNIT_LOCALE.MEGABYTE;
      data.size = Number((size / MAX_UNITS_LENGTH.KBYTE).toFixed(4));
      data.rest = Number((rest / MAX_UNITS_LENGTH.KBYTE).toFixed(4));
    } else if (size >= MAX_UNITS_LENGTH.MEGABYTE) {
      data.displayUnit = UNIT_LOCALE.GIGABYTE;
      data.size = Number((size / MAX_UNITS_LENGTH.MEGABYTE).toFixed(4));
      data.rest = Number((rest / MAX_UNITS_LENGTH.MEGABYTE).toFixed(4));
    }
    if (Number(data === null || data === void 0 ? void 0 : data.rest) > 1) {
      data.rest = parseInt(String(Number(data.rest) * 100), 10) / 100;
    }
  } else if (hasRest && !hasSize) {
    /** только остатки для связь Z и связь Z 2.0 */
    if (rest < MAX_UNITS_LENGTH.KBYTE) {
      data.rest = rest;
      data.displayUnit = UNIT_LOCALE.KBYTE;
    } else if (rest >= MAX_UNITS_LENGTH.KBYTE && rest < MAX_UNITS_LENGTH.MEGABYTE) {
      data.rest = Number((rest / MAX_UNITS_LENGTH.KBYTE).toFixed(1));
      data.displayUnit = UNIT_LOCALE.MEGABYTE;
    } else if (rest >= MAX_UNITS_LENGTH.MEGABYTE) {
      data.rest = Number((rest / (MAX_UNITS_LENGTH.KBYTE * MAX_UNITS_LENGTH.KBYTE)).toFixed(1));
      data.displayUnit = UNIT_LOCALE.GIGABYTE;
    }
  }
  return data;
};
export var formatTimeAccumulator = function formatTimeAccumulator(rest, size) {
  var data = {};
  var hasRest = !!rest || rest === 0;
  var hasSize = !!size || size === 0;
  if (rest >= MAX_UNITS_LENGTH.SECONDS) {
    data.rest = Math.floor(rest / 60);
    data.displayUnit = declension(['минута', 'минуты', 'минут'], data.rest);
  } else {
    data.rest = Number(rest);
    data.displayUnit = declension(['секунда', 'секунды', 'секунд'], data.rest);
  }
  if (size && hasRest && hasSize) {
    data.size = Math.floor(size / 60);
    data.rest = rest < 60 ? rest / 100 : Math.floor(rest / 60);
    data.displayUnit = declension(['минута', 'минуты', 'минут'], data.size);
  }
  return data;
};
var normalizeUnits = function normalizeUnits(_ref) {
  var unit = _ref.unit,
    rest = _ref.rest,
    size = _ref.size;
  switch (unit) {
    case AccumUnit.KBYTE:
      {
        return formatInternetAccumulator(rest, size);
      }
    case AccumUnit.SECONDS:
      {
        return formatTimeAccumulator(rest, size);
      }
    default:
      {
        return {
          displayUnit: unit,
          rest: rest
        };
      }
  }
};
export var convertAccumulators = function convertAccumulators(acc) {
  if (!acc || !acc.length) return emptyArr;
  return acc.map(function (item) {
    return _objectSpread(_objectSpread({}, item), normalizeUnits(item));
  });
};